import { AfterViewInit, Component, ElementRef, OnDestroy, ViewChild, inject } from '@angular/core';
import { ModalStateService } from '../../services';

/**
 * The component displayed in the confirmation modal opened by the ModalService.
 */
@Component({
  selector: 'lib-modal-component',
  styleUrls: ['modal.component.scss'],
  templateUrl: 'modal.component.html',
})
export class ModalComponent implements AfterViewInit, OnDestroy {
  private readonly state = inject(ModalStateService);

  @ViewChild('modalContainer') modalContainer!: ElementRef<HTMLDivElement>;
  @ViewChild('modalContent') modalContent!: ElementRef<HTMLDivElement>;
  @ViewChild('submitButton') submitButton!: ElementRef<HTMLButtonElement>;
  @ViewChild('cancelButton') cancelButton!: ElementRef<HTMLButtonElement>;
  @ViewChild('closeButton') closeButton!: ElementRef<HTMLButtonElement>;

  get options() {
    return this.state.options;
  }

  ngAfterViewInit() {
    if ('parentIFrame' in window) {
      (window as any)['parentIFrame']?.getPageInfo((info: any) => {
        const modal = this.modalContainer.nativeElement;
        modal.style.top = `${Math.max(0, info.scrollTop - info.offsetTop) + 200}px`;
      });
    }

    const defaultFocusElRef = {
      content: this.modalContent,
      submit: this.submitButton,
      cancel: this.cancelButton,
      close: this.closeButton,
    }[this.options.defaultFocus ?? 'content'];
    defaultFocusElRef?.nativeElement?.focus();
  }

  ngOnDestroy() {
    if ('parentIFrame' in window) (window as any)['parentIFrame']?.getPageInfo(false);
  }

  yes() {
    this.state.modal.close('confirmed');
  }

  no() {
    this.state.modal.dismiss('not confirmed');
  }
}
